import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import ModalManager from "../../shared/modal";
import ModalManagerV2 from "../../shared/modal_v2";
import Modal_Confirm_Delete from "../../shared/components/modal_confirm_delete";
import {UnitTypes} from "../values";
import DateUtilities from "../../shared/utilities/date_utilities";
import Auth from "../../shared/auth";
import UnitUtilities from "../../shared/utilities/unit_utilities";
import Modal_Scorm_Activity from "./modal_scorm_activity";
import Modal_Scorm_Progress_Preview from "./modal_scorm_preview";
import Modal_Manage_Session_Enrolment from "./modal_manage_session_enrolment";
import Modal_Approval_Reject from "./modal_approval_reject";
import RouterService from "../../shared/services/router.service";
import SessionController from "../../shared/session";
import {
    createOption,
    EnrolmentStatus,
    getCourseEnrolmentStatus
} from "../../shared/utilities/courseEnrolmentStatus_utilities";
import Modal_Form from "../../public/course/modal_form";
import { changeEnrolmentStatusPrompt } from '../../shared/utilities/confirmStatusChange_utilities';
import Modal_Edit_Enrolment from './modal_edit_enrolment';
import Modal_Assessment_Form from "../../public/course/modal_assessment_form";
import Modal_Assessment_Result from "./modal_assessment_result";
import Modal_Unit_Assessment_History from "./modal_unit_assessment_history";

let enrolmentId, loading, enr, checklist, selected = [], selectedForResult = [];
let saving = false;
let unitApproverMap = {};   //UnitId -> boolean, true if current user configured approver of unit

function reloadEnrolment() {
    return Requester.get(Gateway.admin + "courses/enrolments/" + enr.properties.id)
        .then(function (result) {
            enr = result;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            loading = false;
        });
}

function loadEnrolment(id) {
    loading = true;
    selected = []
    selectedForResult = []
    Requester.get(Gateway.admin + "courses/enrolments/" + id)
        .then(function (result) {
            enr = result;
            loadChecklist(enr.properties.courseId);

            enr.properties.unitEnrolments
                .filter(unitEnrolment => unitEnrolment.unitType === 'Approval' || unitEnrolment.unitType === 'Assessment')
                .map(unit =>
                    loadApprovalUnit(unit.unitId)
                        .then(function (result) {
                            unitApproverMap[unit.unitId] = unit.unitType === 'Assessment' ?
                                result.properties.assessorIds.includes(SessionController.session.identity.id) :
                                result.properties.approverIds.includes(SessionController.session.identity.id);
                        })
                );
        }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
            loading = false;
        });
}

function loadChecklist(courseId) {
    Requester.get(Gateway.admin + "courses/" + courseId + "/checklist")
        .then(function (result) {
            checklist = result.properties.checklist;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function toggleEnrolmentChecklistItem(itemId) {
    loading = true;
    Requester.post(Gateway.admin + "courses/enrolments/" + enr.properties.id + "/checklist/" + itemId)
        .then(function () {
            const itemIndex = enr.properties.checklist.indexOf(itemId);
            if (itemIndex === -1)
                enr.properties.checklist.push(itemId);
            else
                enr.properties.checklist.splice(itemIndex, 1);
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        loading = false;
    });
}

function changeEnrolmentResult(status, effectiveDate) {
    changeResult("courses", status, [enr.properties.id], effectiveDate);
}

function changeUnitResult(status) {
    if (selected) {
        loading = true;
        selectedForResult.push({ courseId: enr.properties.courseId, ids: [enr.properties.id] });
        Requester.post(Gateway.admin + "units/enrolments/result", {
            ids: selected,
            status: status,
            isCancelled: false,
            selectedCourseWithEnrolments: selectedForResult,
            courseEnrolmentIds: [enr.properties.id]})
            .then(function () {
                return reloadEnrolment();
            }).then(function () {
                Toasts.add("success", i18n.t("saved_changes"), "");
            }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
            loading = false;
        });
    }
}

function changeResult(type, status, ids, effectiveDate) {
    loading = true;
    selectedForResult.push({ courseId: enr.properties.courseId, ids: ids });
    Requester.post(Gateway.admin + type + "/enrolments/result", {
        ids: ids,
        status: status,
        effectiveDate: effectiveDate,
        courseId: enr.properties.courseId,
        selectedCourseWithEnrolments: selectedForResult
    }).then(function () {
            return reloadEnrolment();
        }).then(function () {
            Toasts.add("success", i18n.t("saved_changes"), "");
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        loading = false;
    });
}

function submitArchiveEnrolment(status) {
    const isArchived = "archived" === status;
    loading = true;
    Requester.post(Gateway.admin + "courses/enrolments/archive", {ids: [enr.properties.id], isArchived: isArchived, skipUnarchiveLatestActiveEnrolment: true})
        .then(function () {
            return reloadEnrolment();
        }).catch(function (error) {
        Toasts.add("error", i18n.t("cant_save"), error.response.status.detail);
        loading = false;
    });
}

function openScormActivity(unitEnr) {
    ModalManager.open(i18n.t("interactive_unit_activity"), ["modal-wide"], Modal_Scorm_Activity, {unitEnrolment: unitEnr});
}

function openScormPreview(unitEnr) {
    ModalManager.open(i18n.t("Unit_Progress_read_only"), ["modal-huge", "modal-fill-height"], Modal_Scorm_Progress_Preview, {unitEnrolment: unitEnr});
}

function manageSessionEnrolment(unit) {
    ModalManager.open(i18n.t("manage_session_enrolment"), [], Modal_Manage_Session_Enrolment, {
        unit: unit,
        callback: reloadEnrolment,
        cancelCallback: confirmCancelSessionEnrolment
    });
}

function viewFormResponse(readOnly, unit, enrolmentId) {
    let classes = !readOnly ? ["no-close"] : [];
    ModalManager.open(unit.unitName, classes, Modal_Form, {
        enrolmentId: enrolmentId,
        readOnly: readOnly,
        loadFromAdmin: true,
        unitEnrolmentId: unit.id,
        callback: reloadEnrolment
    });
}

function viewAssessmentFormResponse(unit, enrolmentId) {
    let classes = !unit.isPassed ? ["no-close"] : [];
    ModalManager.open(unit.unitName, classes, Modal_Assessment_Form, {
        enrolmentId: enrolmentId,
        readOnly: unit.isPassed,
        loadFromAdmin: true,
        unitEnrolmentId: unit.id,
        callback: reloadEnrolment
    });
}

function showHistory(unit) {
    loading = true;
    Requester.get(Gateway.admin + "units/assessment/" + unit.id + "/history")
        .then(function (result) {
            if (result && result.length > 0)
                ModalManager.open(i18n.t("history"), ["modal-huge"], Modal_Unit_Assessment_History, {history: result});
            else
                Toasts.add("warn", i18n.t("no_history_found"));
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            loading = false;
        });
}

function confirmCancelSessionEnrolment(unit) {
    if (!Auth.validateRights(["enrolments_edit"])) {
        return;
    }
    ModalManager.open(unit.properties.isCancelled ? i18n.t("restore_session_enrolment") : i18n.t("cancel_session_enrolment"), [], Modal_Confirm_Delete, {
        text: unit.properties.isCancelled ? i18n.t("restore_attendance_in_session") : i18n.t("cancel_attendance_in_session"),
        btnText: unit.properties.isCancelled ? i18n.t("restore_session_enrolment") : i18n.t("cancel_session_enrolment"),
        callback: function () {
            cancelSessionEnrolment(unit);
        }
    });
}

function cancelSessionEnrolment(unit) {
    loading = true;
    Requester.post(Gateway.admin + "units/event/enrolments/cancel", {ids: [unit.properties.id], isCancelled: !unit.properties.isCancelled})
        .then(function () {
            return reloadEnrolment();
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        loading = false;
    });
}

function toggleAllSelected() {
    if (selected.length > 0)
        selected = [];
    else {
        if (enr.entities) {
            for (let i = 0; i < enr.entities.length; i++) {
                if(!enr.entities[i].properties.isArchived) {
                    selected.push(enr.entities[i].properties.id);
                }
            }
        }
    }
}

function toggleSelected(id) {
    const index = selected.indexOf(id);
    if (index === -1)
        selected.push(id);
    else
        selected.splice(index, 1);
}

function updateApprovalUnitEnrolment(unit, status, message, user, unitReturned) {
    saving = true;
    Requester.post(Gateway.admin + "units/approval/enrolments/" + unit.properties.id, {
            id: unit.properties.id,
            unitId: unit.properties.unitId,
            isApproved: status,
            approverFeedback: message,
            approverName: user,
            unitReturned: unitReturned
        })
        .then(function () {
            return reloadEnrolment();
        }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
            saving = false;
        })
}

function rejectApprovalUnit(unit, user) {
    ModalManager.open(i18n.t("return_approval_unit"), [], Modal_Approval_Reject,
        {
            unitEnrolment: unit,
            user: user,
            callback: updateApprovalUnitEnrolment}
    );
}

function updateAssessmentUnitEnrolment(unit, status, message, user, unitReturned) {
    saving = true;
    Requester.post(Gateway.admin + "units/assessment/enrolments/" + unit.properties.id, {
        id: unit.properties.id,
        unitId: unit.properties.unitId,
        isAssessed: status,
        assessorFeedback: message,
        assessorName: user,
        AssessmentUnitReturned: unitReturned

    })
        .then(function () {
            return reloadEnrolment();
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        saving = false;
    })
}

function updateAssessmentUnitResult(unit, user, isPassed) {
    ModalManager.open( isPassed ?
            i18n.t("assessment_unit") + ": " + i18n.t("passed") :
            i18n.t("assessment_unit") + ": " + i18n.t("not_yet_competent"),
        [], Modal_Assessment_Result,
        {
            unitEnrolment: unit,
            user: user,
            isPassed: isPassed,
            callback: updateAssessmentUnitEnrolment}
    );
}

function getUnitLabel(unit) {
    if (unit.unitType === UnitTypes.event && unit.isCancelled) {
        return m(".label-circle label-error", i18n.t("cancelled"));
    } else if (unit.unitType === UnitTypes.event && unit.isArchived) {
        return m(".label-circle label-error", i18n.t("archived"));
    } else if (unit.unitType === UnitTypes.approval) {
        if (unit.isCompleted && unit.isPassed)
            return m(".label-circle label-success", i18n.t("approved"));
        else if (unit.resubmitted)
            return m(".label-circle label-warning", i18n.t("submitted"));
        else if (unit.unitReturned && !unit.isPassed)
            return m(".label-circle label-warning", i18n.t("returned"));
        else if (unit.submitted)
            return m(".label-circle label-warning", i18n.t("submitted"));
        else
            return m(".label-circle", i18n.t("not_submitted"))
    } else if (unit.unitType === UnitTypes.assessment) {
        if (unit.isCompleted && unit.isPassed)
            return m(".label-circle label-success", i18n.t("passed"));
        else if (unit.assessmentReSubmitted)
            return m(".label-circle label-warning", i18n.t("in_progress"));
        else if (unit.assessmentUnitReturned && !unit.isPassed)
            return m(".label-circle label-warning", i18n.t("not_yet_competent"));
        else if (unit.assessmentSubmitted)
            return m(".label-circle label-warning", i18n.t("in_progress"));
        else
            return m(".label-circle", i18n.t("not_assessed"))
    } else {
        if (unit.isCompleted && unit.isPassed)
            return m(".label-circle label-success", i18n.t("passed"));
        else if (unit.isCompleted && !unit.isPassed)
            return m(".label-circle label-error", i18n.t("failed"));
        else if (unit.isStarted)
            return m(".label-circle label-warning", i18n.t("in_progress"));
        else
            return m(".label-circle", i18n.t("not_started"));
    }
}

function loadApprovalUnit(id) {
    loading = true;

    return Requester.get(Gateway.admin + "units/" + id)
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
            loading = false;
        });
}

function downloadUploadUnitEnrolmentFile(unit) {
    loading = true;
    Requester.get(Gateway.admin + "units/enrolments/" + unit.properties.id)
        .then(function (result) {
            if (!result.properties.filePath)
                Toasts.add("error", i18n.t("file_not_found"));
            else
                window.open(result.properties.filePath, '_self');
        }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
            loading = false;
        });
}

function populateEnrolmentChangeResultOptions() {
    const optionsMap = {
        notStarted: createOption(EnrolmentStatus.NOT_STARTED, changeEnrolmentStatusPrompt, changeEnrolmentResult, enr?.properties?.isPassed),
        passed: createOption(EnrolmentStatus.PASSED, showChangeEnrolmentStatusWithDatePrompt, enr),
        failed: createOption(EnrolmentStatus.FAILED, changeEnrolmentStatusPrompt, changeEnrolmentResult, enr?.properties?.isPassed),
        archived: createOption(EnrolmentStatus.ARCHIVED, changeEnrolmentStatusPrompt, submitArchiveEnrolment),
        unArchived: createOption(EnrolmentStatus.UN_ARCHIVED, changeEnrolmentStatusPrompt, submitArchiveEnrolment),
    };

    let options = [];
    if (Auth.validateRights(["enrolments_edit"])) {
        if(enr.properties.isArchived) {
            options = [optionsMap.unArchived]
        } else {
            options = [optionsMap.notStarted, optionsMap.passed, optionsMap.failed];
            if(Auth.validateRights([Auth.rights.enrolments_delete])) {
                options.push(optionsMap.archived);
            }
        }
    } else if (Auth.validateRights(["enrolments_reset"])) {
        if(!enr.properties.isArchived) {
            options = [optionsMap.notStarted];
        }
    }

    return options.length ?
        m(".dropdown",
            m("button.with-icon pl-2", [
                m("i.icon-edit"),
                i18n.t("change_result"),
                m("i.icon-back rotate-270 ml-2")
            ]),
            m(".dropdown-list", options)
        )
        : null;
}

function populateUnitChangeResultOptions() {

    const optionsMap = {
        notStarted: createOption(EnrolmentStatus.NOT_STARTED, changeEnrolmentStatusPrompt, changeUnitResult, enr?.properties?.isPassed),
        passed: createOption(EnrolmentStatus.PASSED, changeEnrolmentStatusPrompt, changeUnitResult),
        failed: createOption(EnrolmentStatus.FAILED, changeEnrolmentStatusPrompt, changeUnitResult, enr?.properties?.isPassed),
    };

    let options = [];
    if(Auth.validateRights(["enrolments_edit"])) {
        options = [optionsMap.notStarted, optionsMap.passed, optionsMap.failed];
    } else if (Auth.validateRights(["enrolments_reset"])) {
        if(!enr.properties.isArchived) {
            options = [optionsMap.notStarted];
        }
    }

    return options.length
        ? m(".dropdown", {class: selected.length === 0 ? "disabled" : ""},
            m("button.with-icon pl-2", [
                m("i.icon-edit"),
                i18n.t("change_result"),
                m("i.icon-back rotate-270 ml-2")
            ]),
            m(".dropdown-list", options)
        )
        : null;
}

function showButtonsIfUserAuthorisedApprover(unitEnrolment) {
    let buttonOutput = [
        !unitEnrolment.properties.isCompleted || !unitEnrolment.properties.isPassed ? m("button.btn-text", {
            onclick: function () {
                updateApprovalUnitEnrolment(unitEnrolment, true, "Your request has been approved. If your course has additional modules to complete, please move forward with these.",
                    SessionController.session.identity.name);
            }
        }, i18n.t("approve")) : "",
        !unitEnrolment.properties.isCompleted || !unitEnrolment.properties.isPassed ? m("button.btn-text", {
            onclick: function () {
                rejectApprovalUnit(unitEnrolment, SessionController.session.identity.name);
            }
        }, i18n.t("return")) : "",
    ]

    if(unitApproverMap[unitEnrolment.properties.unitId]) return buttonOutput;
    if(Auth.validateRights(["unit_approval_action"])) return buttonOutput;

    return "";
}

function showButtonsIfUserAuthorisedAssessor(unitEnrolment) {
    let buttonOutput = [
        !unitEnrolment.properties.isCompleted || !unitEnrolment.properties.isPassed ?
            m("button.btn-text", {
                class: !unitEnrolment.properties.assessmentSubmitted ? "disabled" : "",
                onclick: function () {
                    updateAssessmentUnitResult(unitEnrolment, SessionController.session.identity.name, true);
                }
            }, i18n.t("passed")) : "",
        !unitEnrolment.properties.isCompleted || !unitEnrolment.properties.isPassed ? m("button.btn-text", {
            class: !unitEnrolment.properties.assessmentSubmitted ? "disabled" : "",
            onclick: function () {
                updateAssessmentUnitResult(unitEnrolment, SessionController.session.identity.name, false);
            }
        }, i18n.t("not_yet_competent")) : "",
        m("button.btn-text", {
            onclick: function () {
                viewAssessmentFormResponse(unitEnrolment.properties, enrolmentId);
            }
        }, i18n.t("view_checklist")),
        m("button.btn-text", {
            onclick: function () {
                showHistory(unitEnrolment.properties);
            }
        }, i18n.t("history"))
    ]

    if(unitApproverMap[unitEnrolment.properties.unitId]) return buttonOutput;
    if(Auth.validateRights(["unit_assessment_action"])) return buttonOutput;

    return "";
}

const ExpandableCell = {
    expanded: false,
    view: function (vnode) {
        return m("td", {
            class: ExpandableCell.expanded ? "td-expanded" : "td-truncated",
            onclick: () => {
                ExpandableCell.expanded = !ExpandableCell.expanded;
            }
        }, vnode.attrs.text);
    }
};

function showChangeEnrolmentStatusWithDatePrompt(enrolment, status) {
    ModalManagerV2.open(i18n.t("edit_enrolment"), [], Modal_Edit_Enrolment,
        {
            enrolments: [enrolment],
            status: status,
            confirmCallback: changeEnrolmentResult
        }
    );
}

const Page_Enrolment = {
    oninit: function (vnode) {
        enrolmentId = vnode.attrs.id;
        loadEnrolment(vnode.attrs.id);
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section", [
                        m("h1", i18n.t("enrolment"))
                    ]),
                    enr ? [
                        m(".toolbar-section", [
                            populateEnrolmentChangeResultOptions()
                        ])
                    ] : ""
                ])
            ]),
            m(".content-box", [
                m(".flex-auto", [
                    m(".details-list", [
                        m(".form-section", [
                            enr && enr.properties.isArchived ? m(".label label-warning", i18n.t("enrolment_archived")) : ""
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("course")),
                            enr ? (Auth.validateRights(["courses_view"]) ? m(m.route.Link, {
                                href: RouterService.getCourseUrl(enr.properties.courseId),
                                class: "btn-open"
                            }, enr.properties.courseName) : enr.properties.courseName) : m(".loading-dots"),
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("user")),
                            enr ? (Auth.validateRights(["users_view"]) ? m(m.route.Link, {
                                href: RouterService.getAdminUserUrl(enr.properties.userId),
                                class: "btn-open"
                            }, enr.properties.firstName ? enr.properties.firstName + " " + enr.properties.lastName : i18n.t("invited_user")) : enr.properties.firstName ? enr.properties.firstName + " " + enr.properties.lastName : i18n.t("invited_user")) : m(".loading-dots")
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("result")),
                            getCourseEnrolmentStatus(enr, true, loading)
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("created")),
                            enr ? DateUtilities.getFormattedDateFromUTC(enr.properties.creationDate) || m(".text-gray", "-") : m(".loading-dots")
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("completed")),
                            enr ? DateUtilities.getFormattedDateFromUTC(enr.properties.completionDate) || m(".text-gray", "-") : m(".loading-dots")
                        ]),
                        m(".form-section", [
                            m(".text-label", i18n.t("last_launched")),
                            enr ? DateUtilities.getFormattedDateFromUTC(enr.properties.lastActiveDate) || m(".text-gray", "-") : m(".loading-dots")
                        ]),
                        enr?.properties?.selfEnrolmentExpires
                            ? (() => {
                                const expiryDate = new Date(enr.properties.selfEnrolExpiryDate);
                                const isExpired = expiryDate < new Date();

                                return m(".form-section", [
                                    m(".text-label", i18n.t("expiry_date")),
                                    enr.properties.selfEnrolExpiryDate ? m(
                                        ".text-date",
                                        { class: isExpired ? "text-error" : "" },
                                        DateUtilities.getFormattedDateFromUTC(enr.properties.selfEnrolExpiryDate)
                                    ) : '-'
                                ]);
                            })()
                            : null
                    ]),
                    enr && checklist && checklist.length > 0 ? [
                        m(".form-section", [
                            m(".text-label", i18n.t("checklist")),
                            checklist.map(function (item) {
                                return [
                                    m("", {
                                        onclick: Auth.validateRights(["enrolments_edit"], function () {
                                            toggleEnrolmentChecklistItem(item.id);
                                        }), class: Auth.validateRights(["enrolments_edit"], "c-hand")
                                    }, [
                                        m("i.mr-1", {class: enr.properties.checklist.indexOf(item.id) !== -1 ? "icon-checkbox-checked" : "icon-checkbox-empty"}), item.name
                                    ])
                                ];
                            })
                        ])
                    ] : ""
                ])
            ]),
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section", [
                        m("h3", i18n.t("unit_enrolments"))
                    ]),
                    enr && !enr.properties.isArchived ? [m(".toolbar-section", [
                        populateUnitChangeResultOptions()
                    ])
                    ] : ""
                ]),
                !loading ? [
                    enr && enr.entities.length > 0 ? [
                        m(".table-wrapper", [
                            m("table.full-width", [
                                m("thead",
                                    m("tr", [
                                        !enr.properties.isArchived ? m("th", m(".toolbar-checkbox", {onclick: toggleAllSelected}, m("i", {class: selected.length > 0 ? "icon-checkbox-checked" : "icon-checkbox-empty"}))) : "",
                                        m("th", i18n.t("unit")),
                                        m("th", i18n.t("type")),
                                        m("th", i18n.t("result")),
                                        m("th", i18n.t("actions"))
                                    ])
                                ),
                                m("tbody", enr.entities.map(function (unit) {
                                    return [
                                        m("tr", [
                                            !enr.properties.isArchived ? m("td.list-checkbox c-hand pl-1 pr-1", {
                                                class: unit.properties.isArchived ? "disabled" : "",
                                                onclick: function () {
                                                    toggleSelected(unit.properties.id);
                                                }, style: "width: 18px;"
                                            }, m("i", {class: selected.indexOf(unit.properties.id) !== -1 ? "icon-checkbox-checked" : "icon-checkbox-empty"})) : "",
                                            m("td.text-bolder", unit.properties.unitName + (unit.properties.unitType === UnitTypes.event && unit.properties.sessionName && unit.properties.sessionName !== unit.properties.unitName ? (" - " + unit.properties.sessionName) : "")),
                                            m("td.with-icon", [
                                                m("i", {class: UnitUtilities.getUnitTypeIcon(unit.properties.unitType)}),
                                                unit.properties.unitType
                                            ]),
                                            m("td", getUnitLabel(unit.properties)),
                                            m("td", [
                                                unit.properties.unitType === UnitTypes.scorm ? [
                                                    m("button.btn-text", {
                                                        onclick: function () {
                                                            openScormActivity(unit.properties);
                                                        }
                                                    }, i18n.t("view_activity")),
                                                    m("button.btn-text", {
                                                        onclick: function () {
                                                            openScormPreview(unit.properties);
                                                        }
                                                    }, i18n.t("launch"))
                                                ] : "",
                                                unit.properties.unitType === UnitTypes.event ?
                                                    m("", {class: !Auth.validateRights(["unit_event_view"]) ? "disabled" : ""}, [
                                                        !enr.properties.isArchived ? m("button.btn-text", {
                                                            onclick: function () {
                                                                manageSessionEnrolment(unit);
                                                            }
                                                        }, i18n.t("session_details")) : ""
                                                    ]) : "",

                                                unit.properties.unitType === UnitTypes.approval ? showButtonsIfUserAuthorisedApprover(unit) : "",
                                                unit.properties.unitType === UnitTypes.upload ? [
                                                    unit.properties.filePath ? m("button.btn-text", {
                                                        onclick: function () {
                                                            downloadUploadUnitEnrolmentFile(unit);
                                                        }
                                                    }, i18n.t("download_file")) : ""
                                                ] : "",
                                                unit.properties.unitType === UnitTypes.form ?
                                                    m("", {class: !Auth.validateRights(["enrolments_form_unit_response_view"]) ? "disabled" : ""}, [
                                                        unit.properties.isCompleted ? m("button.btn-text", {
                                                            onclick: function () {
                                                                viewFormResponse(true, unit.properties, enrolmentId);
                                                            }
                                                        }, i18n.t("view_response")) : ""
                                                    ]) : "",
                                                unit.properties.unitType === UnitTypes.assessment ?
                                                    showButtonsIfUserAuthorisedAssessor(unit) : "",
                                            ])
                                        ])
                                    ];
                                }))
                            ])
                        ])
                    ] : m(".text-gray padding", i18n.t("no_units"))
                ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
            ])
        ];
    }
};

export default Page_Enrolment;
